export const STATUS_FILTER_KEY = 'statusFilter'
export const CONVERSATION_TAG_KEY = 'conversationTagFilter'
export const PARTICIPANT_FILTER_KEY = 'participantFilter'
export const ADVANCED_SEARCH_KEY = 'advanced'
export const SORT_KEY = 'sortBy'



// WEBPACK FOOTER //
// ./src/scripts/constants/FilterConstants.js